<template>
  <div
    :class="[
      info.is_full_screen === 1 ? 'full-screen' : 'defult-screen',
      'download',
    ]">
    <div
      v-if="info.template_id !== 6"
      :class="className">
      <Banner
        v-if="info.template_id === 5"
        style="padding-top: 20px"></Banner>
      <Toplogo v-if="info.template_id !== 5"></Toplogo>
      <AppInfo
        :btnType="btnType"
        @confirm="handleConfirm"
        @play="handlePlay"></AppInfo>
      <Banner v-if="info.template_id !== 5"></Banner>
      <Introduce></Introduce>
      <Tags v-if="info.template_id !== 5"></Tags>
      <DataSafety @confirm="handleConfirm"></DataSafety>
      <Ratings @confirm="handleConfirm"></Ratings>
      <Moreapps @confirm="handleConfirm"></Moreapps>
      <Footer></Footer>
      <Tabbar @confirm="handleConfirm"></Tabbar>
    </div>
    <div v-else class="w-full">
      <VideoPlay></VideoPlay>
      <IosAppInfo
        :btnType="btnType"
        @confirm="handleConfirm"
        @play="handlePlay"></IosAppInfo>
      <IosActive></IosActive>
      <IosRatings></IosRatings>
      <IosPrivacy @confirm="handleConfirm"></IosPrivacy>
      <IosMoreapps @confirm="handleConfirm"></IosMoreapps>
      <IosTabbar @confirm="handleConfirm"></IosTabbar>
    </div>

    <!-- openChrome -->
    <div
      id="open-chrome"
      v-if="openChrome">
      <div class="mask"></div>
      <div class="bd">
        <h2>{{ info.language_list.dialog.title }}</h2>
        <p>
          {{ info.language_list.dialog.content }}
        </p>
        <span
          class="btn btn-img pop-open-intent"
          @click="openChrome = false"
          >{{ info.language_list.dialog.ok }}</span
        >
      </div>
    </div>
    <div
      id="loading-box"
      v-if="pageLoading">
      <div class="mask"></div>
      <div class="bd">
        <img
          width="45"
          class="rotate"
          src="@/assets/images/loading.svg" />
        <p>{{ info.language_list.basic_info.loading }}</p>
      </div>
    </div>
    <div
      v-if="installPopShow"
      id="pop-show">
      <div class="mask"></div>
      <div class="bd">
        <strong>
          <img src="@/assets/images/lightning.svg" />{{
            info.language_list.dialog.loading
          }}</strong
        >
        <div
          class="loading-ci"
          v-if="loadingBox">
          <div class="loader"></div>
          <span id="count1"></span>
        </div>
        <div
          class="show-btn"
          v-else>
          <div class="active-box">
            <span
              ><img src="@/assets/images/safe.svg" />{{
                info.language_list.dialog.effective
              }}</span
            >
          </div>
          <div class="flex">
            <button
              class="btn"
              @click="handleConfirm">
              {{ info.language_list.dialog.install }}
            </button>
            <button
              class="grey-btn"
              @click="handleClose">
              {{ info.language_list.dialog.close }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { addInstall } from '@/api/index';
import {
  isGoogleChrome,
  setKeyInLocalStorage,
  getLocalStorage,
} from '@/assets/js/utils.js';
import { useStore } from 'vuex';

import Footer from '@/components/android/Footer.vue';
import Toplogo from '@/components/android/Toplogo.vue';
import Tabbar from '@/components/android/Tabbar.vue';
import Moreapps from '@/components/android/Moreapps.vue';
import Ratings from '@/components/android/Ratings.vue';
import DataSafety from '@/components/android/DataSafety.vue';
import Tags from '@/components/android/Tags.vue';
import Introduce from '@/components/android/Introduce.vue';
import Banner from '@/components/android/Banner.vue';
import AppInfo from '@/components/android/AppInfo.vue';

import IosAppInfo from '@/components/ios/AppInfo.vue';
import IosActive from '@/components/ios/Active.vue';
import IosRatings from '@/components/ios/Ratings.vue';
import IosPrivacy from '@/components/ios/Privacy.vue';
import IosMoreapps from '@/components/ios/Moreapps.vue';
import IosTabbar from '@/components/ios/Tabbar.vue';
import VideoPlay from '../../components/ios/VideoPlay.vue';

const route = useRoute();
const store = useStore();
const pageLoading = ref(false); // 页面初始loading
const installPopShow = ref(false); //初次安装弹窗
const loadingBox = ref(false); // 初次安装loading
const currentUrl = ref('');
const openChrome = ref(false);
const storageData = getLocalStorage('localData');
const btnType = ref('loading');
const isFirstLoading =
  storageData && storageData.isFirstLoading !== undefined
    ? ref(storageData.isFirstLoading)
    : ref(0);
const isInstalled = ref(false);
const info = computed(() => store.state.appInfo);

const className = computed(() => {
  return `template-${store.state.appInfo.template_id}`;
});

const isInStandaloneMode = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone ||
  document.referrer.includes('android-app://');

const paramsString = computed(() => {
  let paramsString = '';
  if (route.query.pixel_click_id) {
    paramsString += `&pixel_click_id=${route.query.pixel_click_id}`;
  }
  if (route.query._oks_ext) {
    paramsString += `&_oks_ext=${route.query._oks_ext}`;
  }
  if (route.query.code) {
    paramsString += `&code=${route.query.code}`;
  }
  return paramsString;
});

const handlePlay = () => {
  let uuid = getLocalStorage('localData')?.identification;
  let openUrl = `${window.location.origin}/home?uuid=${uuid}`;
  if (paramsString.value !== '') {
    openUrl = `${window.location.origin}/home?uuid=${uuid}${paramsString.value}`;
  }
  if (isInStandaloneMode()) {
    window.location.href = openUrl;
  } else {
    window.open(openUrl, '_blank');
    console.log('浏览器中打开');
  }
};

const proessBarStart = () => {
  let progress = 0;
  btnType.value = 'installing';
  setKeyInLocalStorage('localData', 'installType', 'installing');
  nextTick(() => {
    const progressBar = document.getElementById('proess');
    const progressText = document.getElementById('count');
    const interval = setInterval(() => {
      progress++;
      progressBar.style.width = `${progress}%`;
      progressText.textContent = `${progress}`;
      if (progress === 100) {
        clearInterval(interval);
        btnType.value = 'loading';
        setTimeout(() => {
          isInstalled.value = true;
          btnType.value = 'play';
          setKeyInLocalStorage('localData', 'installType', 'play');
        }, 2000);
      }
    }, 100);
  });
};

const handleConfirm = () => {
  if (window.deferredPrompt) {
    installPopShow.value = false;
    setKeyInLocalStorage('localData', 'isFirstLoading', 1);
    window.deferredPrompt.prompt();
    window.deferredPrompt.userChoice.then(async (choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        if (!isInStandaloneMode()) proessBarStart();
        // await installApp();
        isPWA();
        console.log('accepted');
      } else {
        btnType.value = 'install';
        isInstalled.value = false;
        console.log('User dismissed the A2HS prompt');
      }
      window.deferredPrompt = null;
    });
  } else {
    var isiOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isGoogleChrome()) {
      if (isFirstLoading) {
        firstInstallLoading();
      }
    } else {
      if (isiOS) {
        if (info.value.ios_url !== '') {
          window.open(info.value.ios_url);
        } else {
          window.open(info.value.h5_url);
        }
      } else {
        if (info.value.android_url !== '') {
          window.open(info.value.android_url);
        }
      }
    }
  }
};

const handleClose = () => {
  installPopShow.value = false;
};

const installApp = () => {
  addInstall({
    app_id: window.location.host,
    pixel_click_id: route.query.pixel_click_id
      ? route.query.pixel_click_id
      : '',
    _oks_ext: route.query._oks_ext ? route.query._oks_ext : '',
    code: route.query.code ? route.query.code : '',
  }).then((res) => {});
};

const isPWA = () => {
  if (isInStandaloneMode()) {
    // PWA 已安装
    isInstalled.value = true;
    btnType.value = 'play';
    setKeyInLocalStorage('localData', 'installType', 'play');
    console.log('pwa已安装');
  }
};

const firstInstallLoading = () => {
  installPopShow.value = true;
  setKeyInLocalStorage('localData', 'isFirstLoading', 1);
  let progress = 0;
  loadingBox.value = true;
  nextTick(() => {
    const progressText = document.getElementById('count1');
    const interval = setInterval(() => {
      progress++;
      progressText.textContent = `${progress}` + '%';
      if (progress === 100) {
        clearInterval(interval);
        loadingBox.value = false;
      }
    }, 100);
  });
};
onMounted(async () => {
  currentUrl.value = window.location.href;
  await store.dispatch('getAppInfo', {
    app_id:
      process.env.NODE_ENV === 'development'
        ? 'ddz.test.hzbc.top'
        : window.location.host,
    pixel_click_id: route.query.pixel_click_id
      ? route.query.pixel_click_id
      : '',
    _oks_ext: route.query._oks_ext ? route.query._oks_ext : '',
    code: route.query.code ? route.query.code : '',
  });
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isGoogleChrome() === true || isiOS) {
    openChrome.value = false;
  } else {
    openChrome.value = true;
  }
  isPWA();
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.deferredPrompt = e;
    if (!storageData) {
      btnType.value = 'install';
      setKeyInLocalStorage('localData', 'installType', 'install');
    }
  });

  window.addEventListener('appinstalled', async function () {
    console.log('PWA已成功添加到主屏幕');
    window.deferredPrompt = null;
    await installApp();
    // btnType.value = 'play';
    setKeyInLocalStorage('localData', 'installType', 'play');
  });
  if (isFirstLoading.value === 0) {
    pageLoading.value = true;
    setTimeout(() => {
      pageLoading.value = false;
    }, 1000);
  } else {
    pageLoading.value = false;
  }
  if (
    !window.deferredPrompt &&
    storageData &&
    storageData.installType === 'play'
  ) {
    btnType.value = 'play';
  } else {
    btnType.value = 'install';
  }
});
</script>

<style lang="scss">
@import './index.scss';
</style>
